import React, { createContext, useState, useContext, useEffect } from "react";

const IDContext = createContext();

export const useID = () => {
  return useContext(IDContext);
};

export const IDProvider = ({ children }) => {
  const storedId = sessionStorage.getItem("id");
  const [id, setId] = useState(storedId || null);

  useEffect(() => {
    if (id) {
      sessionStorage.setItem("id", id);
    }
  }, [id]);

  return (
    <IDContext.Provider value={{ id, setId }}>{children}</IDContext.Provider>
  );
};
